import { createApiActions } from '@shared/ngrx-factory/factory.actions';
import { PageableParamInput } from '../../company-management/requests/pageable-param.search';
import { NonBpsProductRequestDtoInput } from '../requests/non-bps-product-request';
import {
  NonBpsProductRequestStep1DtoInput,
  NonBpsProductRequestStep2DtoInput,
  NonBpsProductRequestStep3DtoInput,
  NonBpsProductRequestStep4DtoInput,
} from '../requests/non-bps-registration.request';

export interface RequestState<T> {
  loading: boolean;
  message: string | null;
  response: T | null;
  error: T | null;
}

export interface NonBpsManagementResponse {
  success: boolean;
  message: string;
  data: any;
  statusCode: number;
}

export interface NonBpsManagementState {
  myApplications: RequestState<NonBpsManagementResponse>;
  applicationDetail: RequestState<NonBpsManagementResponse>;
  productRequests: RequestState<NonBpsManagementResponse>;
  productRequestDetail: RequestState<NonBpsManagementResponse>;
  approvedTerminals: RequestState<NonBpsManagementResponse>;
  requestProgress: RequestState<NonBpsManagementResponse>;
  requestAttachmentTypes: RequestState<NonBpsManagementResponse>;
  saveProductRequest: RequestState<NonBpsManagementResponse>;
  saveRequestQuantities: RequestState<NonBpsManagementResponse>;
  saveRequestArrivalDetails: RequestState<NonBpsManagementResponse>;
  saveRequestSupplierDetails: RequestState<NonBpsManagementResponse>;
  saveRequestConsigneeDetails: RequestState<NonBpsManagementResponse>;
  uploadRequestAttachment: RequestState<NonBpsManagementResponse>;
  viewRequestAttachment: RequestState<NonBpsManagementResponse>;
  deleteRequestAttachment: RequestState<NonBpsManagementResponse>;
  submitProductRequest: RequestState<NonBpsManagementResponse>;
  deleteProductRequest: RequestState<NonBpsManagementResponse>;
}

export const NonBpsMyApplicationsActions = createApiActions<
  PageableParamInput,
  NonBpsManagementResponse
>('Non BPS Management', 'My Applications');

export const NonBpsApplicationDetailActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Application Detail');

export const NonBpsProductRequestsActions = createApiActions<
  PageableParamInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Product Requests');

export const NonBpsProductRequestDetailActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Product Request Detail');

export const NonBpsApprovedTerminalsActions = createApiActions<
  PageableParamInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Approved Terminals');

export const NonBpsRequestProgressActions = createApiActions<string, NonBpsManagementResponse>(
  'Non BPS Management',
  'Request Progress',
);

export const NonBpsRequestAttachmentTypesActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Request Attachment Types');

export const NonBpsSaveProductRequestActions = createApiActions<
  NonBpsProductRequestDtoInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Save Product Request');

export const NonBpsSaveRequestQuantitiesActions = createApiActions<
  NonBpsProductRequestStep1DtoInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Save Request Quantities');

export const NonBpsSaveRequestArrivalDetailsActions = createApiActions<
  NonBpsProductRequestStep2DtoInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Save Request Arrival Details');

export const NonBpsSaveRequestSupplierDetailsActions = createApiActions<
  NonBpsProductRequestStep3DtoInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Save Request Supplier Details');

export const NonBpsSaveRequestConsigneeDetailsActions = createApiActions<
  NonBpsProductRequestStep4DtoInput,
  NonBpsManagementResponse
>('Non BPS Management', 'Save Request Consignee Details');

export const NonBpsUploadRequestAttachmentActions = createApiActions<
  {
    attachableUuid: string;
    registrationAttachmentTypeUuid: string;
    filename: string;
    extension: string | null;
    data: string;
  },
  NonBpsManagementResponse
>('Non BPS Management', 'Upload Request Attachment');

export const NonBpsViewRequestAttachmentActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'View Request Attachment');

export const NonBpsDeleteRequestAttachmentActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Delete Request Attachment');

export const NonBpsSubmitProductRequestActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Submit Product Request');

export const NonBpsDeleteProductRequestActions = createApiActions<
  string,
  NonBpsManagementResponse
>('Non BPS Management', 'Delete Product Request');
